/**
 * Transforms a point by a given scale.
 */
export const scalePoint = (scale) => (point) => ({
    x: point.x * scale,
    y: point.y * scale
});
export const addPoints = (p1, p2) => {
    return {
        x: p1.x + p2.x,
        y: p1.y + p2.y
    };
};
/**
 * Subtracts point p2 from point p1.
 */
export const subtractPoints = (p1, p2) => {
    return {
        x: p1.x - p2.x,
        y: p1.y - p2.y
    };
};
/**
 * Returns the center point for given dimensions.
 */
export const centerPoint = (dimensions) => {
    return {
        x: dimensions.width / 2,
        y: dimensions.height / 2
    };
};
/**
 * Returns the euclidian distance between two points.
 */
export const distanceBetweenPoints = (p1, p2) => {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
};
